import { combineReducers } from 'redux';
import qrAuthReducer from './QrAuth';
import vehicleCapableReducer from './VehicleCapable';
import subscriptionReducer from './Subscriptions';
import forgerockReducer from './ForgeRock';
import remoteStatusReducer from './UpdateRemoteSubscription';

const appReducer = combineReducers({
  qrValue: qrAuthReducer,
  vehicleCapable: vehicleCapableReducer,
  subscription: subscriptionReducer,
  forgerock: forgerockReducer,
  remoteStatus: remoteStatusReducer,
});

export default appReducer;
